import { combineReducers } from 'redux';

import appReducer from '../slices/appSlice.js';

import findingsReducer from '../../riskManager/redux/slices/findingsSlice.js';
import referenceReducer from '../../riskManager/redux/slices/referenceSlice.js';

// NOTE: every key here must also appear in the `whitelist` in src/redux/store.js, or that
// slice silently stops persisting across reloads — persistence is sessionStorage with an
// explicit whitelist, not a blocklist.
const rootReducer = combineReducers({
  app: appReducer,
  findings: findingsReducer,
  reference: referenceReducer,
});

export default rootReducer;
